import React from 'react'
import PropTypes from 'prop-types'
import { Box, LinearProgress } from '@mui/material'

import ScoreCard from './ScoreCard'

const ScoresList = ({ isFullscreen, allScores, isLoading }) => {
  return (
    <>
      {(isLoading && !isFullscreen) ? <LinearProgress /> : <Box sx={{ height: '4px' }} />}

      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        padding: isFullscreen ? 0 : '20px'
      }}
      >
        {allScores.map((scoreInfo, i) => (
          <ScoreCard key={i} name={scoreInfo.name} score={scoreInfo.hydrationScore} />
        ))}
      </Box>

    </>
  )
}

ScoresList.propTypes = {
  isFullscreen: PropTypes.bool,
  allScores: PropTypes.array,
  isLoading: PropTypes.bool
}

export default ScoresList
